import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { Button, Card, CardBody, Col, Container, Form, Input, Label, Row } from 'reactstrap';
import { addCCFPointsAPI, getCertificationListAPI } from '../../../../apiConfig/apiCall';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import useReactSelectCustomStyle from '../../../../hooks/useReactSelectCustomStyle';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getCCFFilterList } from '../../../../slices/ManageCCFPoints/getCCFFilterListSlice';
import { toast } from 'react-toastify';
import CreatableSelect from "react-select/creatable";
import { useNavigate } from 'react-router-dom';

export default function AddCCFPoint() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading, isError, data: ccfFilterData } = useSelector(state => state.getCCFFilterListSlice);

    const [certificationListData, setCertificationListData] = useState([]);
    const [visibleCertification, setVisibleCertification] = useState({});
    const [selectedCertificationIds, setSelectedCertificationIds] = useState([]);

    const getCertificationListData = async () => {
        try {
            const apiResponse = await getCertificationListAPI();
            if (apiResponse.status === 200) {
                setCertificationListData(apiResponse.data);
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    const selectBoxCustomStyles = useReactSelectCustomStyle();

    const [domainTitle, setDomainTitle] = useState({ value: '', label: '' });
    const [controlTitle, setControlTitle] = useState({ value: '', label: '' });
    const [controlType, setControlType] = useState({ value: '', label: '' });
    const [department, setDepartment] = useState({ value: '', label: '' });
    const [controlReference, setControlReference] = useState('');
    const [controlWording, setControlWording] = useState('');
    const [controlArtifacts, setControlArtifacts] = useState('');
    const [controlNarrative, setControlNarrative] = useState('');

    const domainTitleOptions = ccfFilterData?.DomainTitle?.map(title => ({ value: title, label: title })) || [];
    const controlTitleOptions = ccfFilterData?.ControlTitle?.map(title => ({ value: title, label: title })) || [];
    const controlTypeOptions = ccfFilterData?.ControlType?.map(type => ({ value: type, label: type })) || [];
    const departmentOptions = ccfFilterData?.Department?.map(dept => ({ value: dept, label: dept })) || [];

    // New state to manage filtered points for each certification
    const [filteredCertificationPoints, setFilteredCertificationPoints] = useState({});

    const handleSearch = (e, certificationId, points) => {
        const searchTerm = e.target.value.toLowerCase();
        const filteredPoints = points.filter((point) =>
            point.controlWording.toLowerCase().includes(searchTerm)
        );
        // Update the filtered points in the state
        setFilteredCertificationPoints(prevState => ({
            ...prevState,
            [certificationId]: filteredPoints
        }));
    };

    const handleCertificationToggle = (certificationId) => {
        setVisibleCertification((prevState) => ({
            ...prevState,
            [certificationId]: !prevState[certificationId],
        }));
    };

    const handleCertificationChange = (certificationId) => {
        setSelectedCertificationIds((prevSelected) => {
            if (prevSelected.includes(certificationId)) {
                return prevSelected.filter((id) => id !== certificationId);
            } else {
                return [...prevSelected, certificationId];
            }
        });
    };


    const handleChangeControlReference = (e) => {
        const maxLength = 10;
        if (e.target.value.length <= maxLength) {
            setControlReference(e.target.value);
        }
    }


    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            console.log("domainTitle", domainTitle)

            if (domainTitle === null) {
                toast.error('Domain Title is required');
                return;
            }

            else if (domainTitle.value === '') {
                toast.error('Domain Title is required');
                return;
            }

            else if (domainTitle.value.length > 100) {
                toast.error('Domain Title cannot exceed 100 characters');
                return;
            }

            if (controlTitle.value === '') {
                toast.error('Control Title is required');
                return;
            } else if (controlTitle.value.length > 100) {
                toast.error('Control Title cannot exceed 100 characters');
                return;
            }

            if (controlReference === '') {
                toast.error('Control Reference is required');
                return;
            } else if (controlReference.length > 10) {
                toast.error('Control Reference cannot exceed 10 characters');
                return;
            }

            if (controlType.value === '') {
                toast.error('Control Type is required');
                return;
            } else if (controlType.value.length > 100) {
                toast.error('Control Type cannot exceed 100 characters');
                return;
            }

            if (department.value === '') {
                toast.error('Department is required');
                return;
            } else if (department.value.length > 100) {
                toast.error('Department cannot exceed 100 characters');
                return;
            }

            else if (controlWording === '') {
                toast.error('Control Wording is required');
                return;
            } else if (controlWording.length > 2000) {
                toast.error('Control Wording must not exceed 2000 characters');
                return;
            } else if (controlArtifacts === '') {
                toast.error('Control Artifacts is required');
                return;
            } else if (controlArtifacts.length > 2000) {
                toast.error('Control Artifacts must not exceed 2000 characters');
                return;
            } else if (controlNarrative === '') {
                toast.error('Control Narrative is required');
                return;
            } else if (controlNarrative.length > 2000) {
                toast.error('Control Narrative must not exceed 2000 characters');
                return;
            }


            const submitData = {
                domainTitle: domainTitle?.value || '',
                controlTitle: controlTitle?.value || '',
                controlReference,
                controlType: controlType?.value || '',
                department: department?.value || '',
                controlWording,
                controlArtifacts,
                controlNarrative,
            };

            const apiResponse = await addCCFPointsAPI(submitData, selectedCertificationIds);
            if (apiResponse.status === 201) {
                toast.success(apiResponse.data);
                navigate('/manage-cff-points')
            }
            else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            }
            else {
                toast.error('Something went wrong');
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        getCertificationListData();
        dispatch(getCCFFilterList());
    }, []);

    return (
        <div className="page-content add-ccf-page">
            <Container fluid>
                <BreadCrumb title={'Add CCF Point'} pageTitle={"Dashboard"} />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row className="gy-3">
                                        <Col lg={4}>
                                            <Label htmlFor="domainTitle" className="form-label">Domain Title</Label>
                                            <CreatableSelect
                                                name="domainTitle"
                                                value={domainTitle}
                                                onChange={(option) => setDomainTitle(option)}
                                                options={domainTitleOptions}
                                                styles={selectBoxCustomStyles}
                                                placeholder="Select or type domain title"
                                                isClearable
                                                onCreateOption={(inputValue) => {
                                                    if (inputValue.length > 100) {
                                                        toast.error('Domain Title cannot exceed 100 characters.');
                                                    } else {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setDomainTitle(newOption);
                                                        domainTitleOptions.push(newOption);
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.target.value.length > 100) {
                                                        e.preventDefault();
                                                        toast.error('Domain Title cannot exceed 100 characters.');
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (inputValue.length > 100) {
                                                        toast.error('Domain Title cannot exceed 100 characters.');
                                                    } else if (inputValue) {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setDomainTitle(newOption);
                                                        domainTitleOptions.push(newOption);
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlTitle" className="form-label">Control Title</Label>
                                            <CreatableSelect
                                                name="controlTitle"
                                                value={controlTitle}
                                                onChange={(option) => setControlTitle(option)}
                                                options={controlTitleOptions}
                                                styles={selectBoxCustomStyles}
                                                placeholder="Select control title"
                                                isClearable
                                                onCreateOption={(inputValue) => {
                                                    if (inputValue.length > 100) {
                                                        toast.error('Control Title cannot exceed 100 characters.');
                                                    } else {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setControlTitle(newOption);
                                                        controlTitleOptions.push(newOption);
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.target.value.length > 100) {
                                                        e.preventDefault();
                                                        toast.error('Control Title cannot exceed 100 characters.');
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (inputValue.length > 100) {
                                                        toast.error('Control Title cannot exceed 100 characters.');
                                                    } else if (inputValue) {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setControlTitle(newOption);
                                                        controlTitleOptions.push(newOption);
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlReference" className="form-label">Control Reference</Label>
                                            <Input
                                                type="text"
                                                id="controlReference"
                                                value={controlReference}
                                                onChange={(e) => handleChangeControlReference(e)}
                                                placeholder="Enter control reference"
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlType" className="form-label">Control Type</Label>
                                            <CreatableSelect
                                                name="controlType"
                                                value={controlType}
                                                onChange={(option) => setControlType(option)}
                                                options={controlTypeOptions}
                                                styles={selectBoxCustomStyles}
                                                placeholder="Select control type"
                                                isClearable
                                                onCreateOption={(inputValue) => {
                                                    if (inputValue.length > 100) {
                                                        toast.error('Control Type cannot exceed 100 characters.');
                                                    } else {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setControlType(newOption);
                                                        controlTypeOptions.push(newOption);
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.target.value.length > 100) {
                                                        e.preventDefault();
                                                        toast.error('Control Type cannot exceed 100 characters.');
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (inputValue.length > 100) {
                                                        toast.error('Control Type cannot exceed 100 characters.');
                                                    } else if (inputValue) {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setControlType(newOption);
                                                        controlTypeOptions.push(newOption);
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="department" className="form-label">Department</Label>
                                            <CreatableSelect
                                                name="department"
                                                value={department}
                                                onChange={(option) => setDepartment(option)}
                                                options={departmentOptions}
                                                styles={selectBoxCustomStyles}
                                                placeholder="Select department"
                                                isClearable
                                                onCreateOption={(inputValue) => {
                                                    if (inputValue.length > 100) {
                                                        toast.error('Department cannot exceed 100 characters.');
                                                    } else {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setDepartment(newOption);
                                                        departmentOptions.push(newOption);
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.target.value.length > 100) {
                                                        e.preventDefault();
                                                        toast.error('Department cannot exceed 100 characters.');
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (inputValue.length > 100) {
                                                        toast.error('Department cannot exceed 100 characters.');
                                                    } else if (inputValue) {
                                                        const newOption = { value: inputValue, label: inputValue };
                                                        setDepartment(newOption);
                                                        departmentOptions.push(newOption);
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col lg={4}></Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlWording" className="form-label">Control Wording</Label>
                                            <Input
                                                type="textarea"
                                                id="controlWording"
                                                placeholder="Enter control wording"
                                                style={{ height: '150px' }}
                                                value={controlWording}
                                                onChange={(e) => setControlWording(e.target.value)}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlArtifacts" className="form-label">Control Supporting Audit Artifacts/ RFI</Label>
                                            <Input
                                                type="textarea"
                                                id="controlArtifacts"
                                                placeholder="Enter control artifacts"
                                                style={{ height: '150px' }}
                                                value={controlArtifacts}
                                                onChange={(e) => setControlArtifacts(e.target.value)}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="controlNarrative" className="form-label">Control Narrative</Label>
                                            <Input
                                                type="textarea"
                                                id="controlNarrative"
                                                placeholder="Enter control narrative"
                                                style={{ height: '150px' }}
                                                value={controlNarrative}
                                                onChange={(e) => setControlNarrative(e.target.value)}
                                            />
                                        </Col>
                                        <Col lg={12}>
                                            <h4>Certifications</h4>
                                            <Row>
                                                {certificationListData.map((certification) => (
                                                    certification.certificationVersionPoints.length > 0 && (
                                                        <Col lg={3} key={certification.id}>
                                                            <div className="d-flex align-items-center mb-2">
                                                                <Input
                                                                    type="checkbox"
                                                                    id={certification.certificationType.toLowerCase()}
                                                                    className="form-check-input me-2 rounded-circle"
                                                                    onChange={() => handleCertificationToggle(certification.id)}
                                                                />
                                                                <Label htmlFor={certification.certificationType.toLowerCase()} className="form-label mb-0">
                                                                    {certification.certificationType}
                                                                </Label>
                                                            </div>

                                                            {visibleCertification[certification.id] && (
                                                                <div>

                                                                    <div className="w-75 mb-2">
                                                                        <Input
                                                                            type="search"
                                                                            className="form-control"
                                                                            placeholder="Search type of filter"
                                                                            onChange={(e) => handleSearch(e, certification.id, certification.certificationVersionPoints)}
                                                                        />
                                                                    </div>

                                                                    <div style={{ height: '10rem', overflowX: "hidden", overflowY: "scroll" }}>
                                                                        {(filteredCertificationPoints[certification.id] || certification.certificationVersionPoints).map((point) => (
                                                                            <div className="form-check mb-2" key={point.id}>
                                                                                <Input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`formCheck${point.id}`}
                                                                                    onChange={() => handleCertificationChange(point.id)}
                                                                                />
                                                                                <Label className="form-check-label" htmlFor={`formCheck${point.id}`}>
                                                                                    {point.certificationIndex}
                                                                                </Label>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                </div>
                                                            )}
                                                        </Col>
                                                    )
                                                ))}
                                            </Row>
                                        </Col>
                                        <Col lg={12}>
                                            <Button color="primary" type="submit" className="me-2">Add CCF</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}